const holidayAwardsGames = ['NewbieRisingStarHoliday', 'IconSuperstarHoliday'] as const;

export { holidayAwardsGames };
